import { render, staticRenderFns } from "./officialBallots.vue?vue&type=template&id=06a9988e&scoped=true&"
import script from "./officialBallots.vue?vue&type=script&lang=js&"
export * from "./officialBallots.vue?vue&type=script&lang=js&"
import style0 from "./officialBallots.vue?vue&type=style&index=0&id=06a9988e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a9988e",
  null
  
)

export default component.exports